"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.encryptByAES = void 0;
const vue_1 = require("vue");
const crypto_js_1 = __importDefault(require("crypto-js"));
const complex_utils_1 = require("complex-utils");
const complex_data_1 = require("complex-data");
const require_1 = __importStar(require("@/require"));
const api_1 = __importDefault(require("@/api"));
const encryptByAES = function (message) {
    return crypto_js_1.default.AES.encrypt(crypto_js_1.default.enc.Utf8.parse(message), crypto_js_1.default.enc.Utf8.parse('ufocstant_login_'), {
        mode: crypto_js_1.default.mode.ECB,
        padding: crypto_js_1.default.pad.Pkcs7
    }).toString();
};
exports.encryptByAES = encryptByAES;
class UserData extends complex_data_1.BaseData {
    constructor(initOption) {
        super(initOption);
        this.page = 'index';
        this.info = {};
        this.$initLoadDepend();
    }
    getAccount() {
        return this.info.account;
    }
    changePage(page) {
        this.page = page;
    }
    setInfo(info) {
        this.info.id = info.id;
        this.info.flowId = info.flowId;
        this.info.account = info.account;
        this.info.name = info.name;
        this.info.role = info.role;
        this.syncLocalInfo();
    }
    getAvatar() {
        return require('@/assets/icon/default-avatar.png');
    }
    syncLocalInfo() {
        (0, complex_utils_1.setLocalData)('user', this.info);
    }
    getDataByLocal() {
        // 从本地缓存获取用户信息和token，成功返回true
        const localInfo = (0, complex_utils_1.getLocalData)('user');
        if (localInfo) {
            const token = require_1.default.getToken('Authorization', 'default');
            if (token) {
                this.setInfo(localInfo);
                require_1.refreshLogin.setRefreshToken((0, complex_utils_1.getLocalData)('refreshToken'));
                this.$setStatus('success', 'load');
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    }
    refreshInfo() {
        return new Promise((resolve) => {
            this.$setStatus('ing', 'operate');
            api_1.default.refreshInfo.require().then((res) => {
                this.setInfo({
                    id: res.data.data.userid,
                    flowId: res.data.data.flowUserId,
                    name: res.data.data.username,
                    account: res.data.data.loginid,
                    role: res.data.data.roleList.map(item => item.roleid)
                });
                this.$setStatus('un', 'operate');
                resolve({ status: 'success' });
            }).catch((err) => {
                this.$setStatus('un', 'operate');
                resolve({ status: 'fail', code: 'login', msg: err.msg });
            });
        });
    }
    getDataByPassword(loginData, codeTime) {
        // 登录获取用户信息和token
        return new Promise((resolve, reject) => {
            this.$setStatus('ing', 'load');
            api_1.default.login.require({
                loginid: (0, exports.encryptByAES)(loginData.username),
                password: (0, exports.encryptByAES)(loginData.password),
                verCode: loginData.captcha,
                checkCodeKey: codeTime
            }).then((res) => {
                this.setToken(res.data.data);
                this.setInfo({
                    id: res.data.data.userid,
                    flowId: res.data.data.flowUserId,
                    name: res.data.data.username,
                    account: res.data.data.loginid,
                    role: res.data.data.roleList.map(item => item.roleid)
                });
                this.$setStatus('success', 'load');
                resolve({ status: 'success' });
            }).catch((err) => {
                this.$setStatus('fail', 'load');
                reject({ status: 'fail', code: 'login', msg: err.msg });
            });
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setToken(data, from = 'login') {
        // 警告，因返回值类型不同，刷新Token的返回需要同步修正
        require_1.default.setToken('Authorization', data.token, 'default');
        require_1.default.setToken('X-Cs-User-Id', (0, exports.encryptByAES)(data.userid), 'default');
        require_1.default.setToken('X-Cs-Flow-User-Id', (0, exports.encryptByAES)(data.flowUserId), 'default');
        require_1.refreshLogin.setRefreshToken(data.secret);
    }
    logout() {
        this.$reset();
    }
}
const user = (0, vue_1.reactive)(new UserData({
    name: '用户',
    prop: 'user'
}));
user.$onLife('reseted', () => {
    user.setInfo({
        id: '',
        flowId: '',
        name: '',
        account: '',
        role: []
    });
    require_1.refreshLogin.setRefreshToken('');
    require_1.default.clearAllToken();
});
require_1.refreshLogin.$onLife('refreshToken', (data) => {
    // 因返回值不完全一致，此处仅更新token相关参数
    require_1.default.setToken('Authorization', data.token, 'default');
    require_1.refreshLogin.setRefreshToken(data.secret);
    user.syncLocalInfo();
});
require_1.refreshLogin.$onLife('logout', () => {
    user.logout();
});
exports.default = user;
